export default __webpack_public_path__ + "static/media/community.d7d58c19.png";